var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.matched)?_c('el-tag',{attrs:{"type":_vm.matched.listClass || '',"size":"small"}},[_vm._v(_vm._s(_vm.matched.dictLabel))]):_c('span',[_vm._v(_vm._s(_vm.value !== null && _vm.value !== undefined ? _vm.value : '-'))])}
var staticRenderFns = []

export { render, staticRenderFns }